// extracted by mini-css-extract-plugin
export var black = "_3h-6";
export var brand = "_3h-1";
export var ddefault = "_3h-0";
export var error = "_3h-3";
export var gray = "_3h-2";
export var highContrast = "_3h-8";
export var outline = "_3h-7";
export var success = "_3h-5";
export var warning = "_3h-4";